import { observer } from 'mobx-react-lite'
import { AccessRequestFolderNotification as AccessRequestFolderNotificationType } from '../../types'
import { AccessRequestNotification } from './AccessRequestNotification'
import { useModals } from 'almanac-ui/Modal'
import { ShareSheet } from 'components/ShareSheet/ShareSheet'

import { ActiveSettingsMember, RecipientsSelectorValueType } from 'types'

interface Props {
  notification: AccessRequestFolderNotificationType
  onClose: () => void
}

export const AccessRequestFolderNotification = observer(({ notification, onClose }: Props) => {
  const subject = notification.subject
  const title = `requested ${subject.requested_permission} access to a folder`
  const path = notification.folder.url
  const { openModal: openNewShareModal } = useModals()

  const openShareModal = () => {
    openNewShareModal(ShareSheet, {
      file: {
        id: notification.folder.key,
        type: 'folder',
      },
      initialRecipients: [{ type: RecipientsSelectorValueType.User, value: subject.sender as ActiveSettingsMember }],
      initialPermission: subject.requested_permission,
    })
  }

  return (
    <AccessRequestNotification
      notification={notification}
      onClose={onClose}
      onClick={subject.permission_granted ? undefined : openShareModal}
      title={title}
      path={path}
      aria-label="Access Request Folder Notification"
    />
  )
})
